<form [formGroup]="searchForm">
  <div>
    <mat-form-field>
      <mat-label>{{ "input-model-brand" | translate }}</mat-label>
      <input
        type="text"
        matInput
        formControlName="name"
        [matAutocomplete]="auto"
        [required]="isRequired"
      />
      <mat-autocomplete
        autoActiveFirstOption
        #auto="matAutocomplete"
        (optionSelected)="onOptionSelected($event)"
      >
        <mat-option
          *ngFor="let currentBrand of brands"
          [value]="currentBrand.name"
          class="autocomplete"
        >
          {{ currentBrand.name }}
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="searchForm.get('name').hasError('required')">
        {{ "required-brand" | translate }}
      </mat-error>
    </mat-form-field>
  </div>
</form>
